import googleIcon from '@/assets/images/icons/google.svg';
import microsoftIcon from '@/assets/images/icons/microsoft.svg';
import { ROUTES } from '@/consts/routes';

export const OAUTH_STRATEGIES = {
  MICROSOFT: 'oauth_microsoft',
  GOOGLE: 'oauth_google',
  LINKEDIN: 'oauth_linkedin',
  APPLE: 'oauth_apple'
} as const;

export const OAUTH_REDIRECT_URL = `${import.meta.env.VITE_BASE_URL}${ROUTES.auth.sso}`;

export const OAUTH_PROVIDERS = [
  { name: 'Microsoft', icon: microsoftIcon, strategy: OAUTH_STRATEGIES.MICROSOFT },
  { name: 'Google', icon: googleIcon, strategy: OAUTH_STRATEGIES.GOOGLE }
] as const;

export type OAuthProvider = (typeof OAUTH_PROVIDERS)[number];
